import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-autocomplete-field-checkbox-filter',
    templateUrl: './autocomplete-field-checkbox-filter.component.html',
    styleUrls: ['./autocomplete-field-checkbox-filter.component.css'],
    standalone: false
})
export class AutocompleteFieldCheckboxFilterComponent {
  @Output() childEvent = new EventEmitter<string>(); // Ensure the type is 'string'

  emitToParent() {
    this.childEvent.emit('Hello from child!');  // Emit a string value
  }
  @ViewChild('fakeclick') fakeclickElement: ElementRef;
  placeholder: string = 'Enter a value';
  formControl: FormControl = new FormControl('');
  filteredOptions: Observable<string[]> = of([]);
  isRequired: boolean = true;
  selectedOptions: string[] = [];  // Track selected options
  allOptions: string[] = ['sonalip', 'prajna', 'rudrap', 'sdlsd', 'mark'];

  onKeyDown(event: KeyboardEvent) {
    // Handle keydown event
  }

  validateSelection() {
    // Handle input blur event and validation logic
  }

  onOptionSelected(value: string) {
    // Handle option selection
    console.log('Option selected:', value);
  }

  onInputChange(event: Event) {
    // Handle input change event and update filtered options
    const inputValue = (event.target as HTMLInputElement).value;
    this.filteredOptions = this.getFilteredOptions(inputValue);
  }

  getFilteredOptions(inputValue: string): Observable<string[]> {
    // Filter options based on the input value and return as an observable
    const filtered = this.allOptions.filter(option =>
      option.toLowerCase().includes(inputValue.toLowerCase())
    );
    return of(filtered); // Ensure the return type is an observable
  }

  fakeClick() {
    // Trigger a click or update action on the element
    console.log('Fake click triggered');
    this.fakeclickElement.nativeElement.click();
  }
   // Handles selection changes
   onSelectionChange(event: any) {
    this.selectedOptions = event.value;  // Update selected options array
    console.log('Selected options:', this.selectedOptions);
  }

  // Check if an option is selected
  isSelected(option: string): boolean {
    return this.selectedOptions.includes(option);
  }
}